import { PartialTheme } from '@fluentui/react';

export const ZoryveDirectTheme: PartialTheme = {
  palette: {
    themePrimary: '#EEC02A',
    themeLighterAlt: '#0a0703',
    themeLighter: '#271d0b',
    themeLight: '#493615',
    themeTertiary: '#936d2b',
    themeSecondary: '#d79f3e',
    themeDarkAlt: '#f6bc59',
    themeDark: '#f7c672',
    themeDarker: '#f9d596',
    neutralLighterAlt: '#ffffff',
    neutralLighter: '#ffffff',
    neutralLight: '#000000',
    neutralQuaternaryAlt: '#4c2c57',
    neutralQuaternary: '#492a53',
    neutralTertiaryAlt: '#462850',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#ffffff',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#408BAB',
  },
  defaultFontStyle: { fontFamily: '"Open Sans", sans-serif' },
  fonts: {
    small: {
      fontSize: '12px',
    },
    medium: {
      fontSize: '16px',
    },
    large: {
      fontSize: '20px',
      fontWeight: 'semibold',
    },
    xLarge: {
      fontSize: '22px',
      fontWeight: 'semibold',
    },
  },
  effects: {
    roundedCorner6: '14px',
  },
};
